/**
 * Minimal chrome for the internal admin console (v1-2-5) — NOT the public
 * marketing Navbar/Footer. A title bar with the operator's role + a sign-out.
 */
import { useNavigate } from 'react-router-dom';
import { clearSession, getRole } from '../lib/auth';

export function AdminShell({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const role = getRole();

  function signOut() {
    clearSession();
    navigate('/admin/login', { replace: true });
  }

  return (
    <div className="min-h-screen bg-surface-alt">
      <header className="border-b border-line bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3">
            <a href="/admin" className="text-sm font-semibold text-ink">
              Corporate Partnerships · Admin
            </a>
            <nav className="hidden items-center gap-1 sm:flex" aria-label="Admin sections">
              <a
                href="/admin"
                className="rounded-lg px-2.5 py-1 text-sm font-medium text-ink-700 transition-colors duration-200 hover:bg-surface-muted"
              >
                Review queue
              </a>
              <a
                href="/admin/deals"
                className="rounded-lg px-2.5 py-1 text-sm font-medium text-ink-700 transition-colors duration-200 hover:bg-surface-muted"
              >
                Deals &amp; Proposals
              </a>
            </nav>
            {role && (
              <span className="rounded-full bg-surface-muted px-2 py-0.5 text-xs font-medium text-ink-500">
                {role}
              </span>
            )}
          </div>
          <button
            type="button"
            onClick={signOut}
            className="rounded-lg border border-line px-3 py-1.5 text-sm font-medium text-ink-700 hover:bg-surface-muted"
          >
            Sign out
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:px-8">
        <h1 className="mb-6 text-xl font-bold text-ink">{title}</h1>
        {children}
      </main>
    </div>
  );
}

export default AdminShell;
